import { SupportedBrowser } from './SupportedBrowser/SupportedBrowser';
import { UnsupportedBrowser } from './UnsupportedBrowser/UnsupportedBrowser';
import { useAppStateContext } from '../../AppStateProvider/AppStateProvider';

export function BrowserTest() {
  const { state } = useAppStateContext();

  return <>{state.isSupported ? <SupportedBrowser /> : <UnsupportedBrowser />}</>;
}
